import { createSlice } from "@reduxjs/toolkit";

export interface UserInfoState {
	name: string;
	role: string;
	email: string;
	username: string;
	id: number | null;
	group_id: string;
	city_id: string;
	import_source: any;
	days_remaining_for_trial: number;
	is_payed: boolean;
}

const initialState: UserInfoState = {
	name: "",
	role: "",
	email: "",
	username: "",
	id: null,
	group_id: "",
	city_id: "",
	import_source: null,
	days_remaining_for_trial: 14,
	is_payed: false,
};

const userInfoReducer = createSlice({
	name: "userInfoReducer",
	initialState,
	reducers: {
		setUserName: (state, action) => {
			state.name = action.payload;
		},
		setUserUsername: (state, action) => {
			state.username = action.payload;
		},
		setUserRole: (state, action) => {
			state.role = action.payload;
		},
		setUserId: (state, action) => {
			state.id = action.payload;
		},
		setGroupId: (state, action) => {
			state.group_id = action.payload;
		},
		setCityId: (state, action) => {
			state.city_id = action.payload;
		},
		setImport: (state, action) => {
			state.import_source = action.payload;
		},
		setTrialInfo: (
			state,
			action: { payload: { days_remaining: number; is_payed: boolean } }
		) => {
			state.days_remaining_for_trial = action.payload.days_remaining;
			state.is_payed = action.payload.is_payed;
		},
		logout: () => initialState,
	},
});

export const {
	setUserName,
	setGroupId,
	setCityId,
	setImport,
	setUserUsername,
	setUserRole,
	setUserId,
	setTrialInfo,
	logout,
} = userInfoReducer.actions;

export default userInfoReducer.reducer;
